import {NetworkAPIVersion, NetworkParamType} from './network.utils';

export default {
  getSuggestions: {
    url: 'api/research-suggestions/{treeId}/',
    apiVersion: NetworkAPIVersion.noVersion,
  },
  postSuggestions: {
    url: 'api/research-suggestions/{treeId}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      accepted_suggestions:[NetworkParamType.array]
    }
  }
}
